export default function ContactUs() {
  return (
    <section  className="py-24 bg-white min-h-screen">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">

          {/* Header */}
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Contact Us
            </h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
              We’re here to help. Whether you have a question, feedback, or need support,
              feel free to reach out. We value every message and aim to respond as quickly as possible.
            </p>
          </div>

          {/* Contact Card */}
          <div className="bg-gradient-to-br from-teal-50 via-emerald-50 to-teal-100 rounded-3xl p-8 md:p-12 border border-teal-100 space-y-10">

            {/* Company */}
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">
                Company
              </h2>
              <p className="text-gray-700">
                FUZZAPP SOLUTIONS PRIVATE LIMITED
              </p>
            </div>

            {/* Address */}
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">
                Registered Office Address
              </h2>
              <p className="text-gray-700 leading-relaxed">
                10th Flr, Nesco Tower 4, C WING <br />
                Western Express Highway <br />
                Goregaon East, Mumbai – 400063 <br />
                Maharashtra, India
              </p>
            </div>

            {/* Email */}
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">
                Email
              </h2>
              <a
                href="mailto:support@fuzzapp.io"
                className="text-teal-600 font-medium hover:underline"
              >
                support@fuzzapp.io
              </a>
            </div>

            {/* Support Hours */}
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">
                Support Hours
              </h2>
              <p className="text-gray-700">
                Monday to Friday, 10:00 AM – 6:00 PM (IST)
              </p>
              <p className="text-sm text-gray-500 mt-1">
                Excluding public holidays
              </p>
            </div>

          </div>

        </div>
      </div>
    </section>
  );
}